import { MiBuildHouseAlt } from "@miplatform/assets";
import { MiButton, MiPlaceholderArea } from "@miplatform/components";
import { BUTTON_VARIANTS, TYPOGRAPHY_VARIANTS } from "@miplatform/constants";
import { mdiPlus } from "@mdi/js";
import { Box, Typography, useTheme } from "@mui/material";
import { ConfigAccordionHeader } from "../../../../../Config/components/ConfigAccordionHeader/ConfigAccordionHeader";

export function CustomerBidLineItemsTab() {
  const theme = useTheme();

  return (
    <ConfigAccordionHeader
      title="Bid Line Items"
      disableCollapse
      customAction={
        <MiButton
          title="Add Bid Line Item"
          variant={BUTTON_VARIANTS.CONTAINED}
          startIcon={{ path: mdiPlus }}
          size="small"
          disabled
        />
      }
    >
      <Box display="flex" flexDirection="column" gap={2}>
        <Typography
          variant={TYPOGRAPHY_VARIANTS.BODY2}
          color={theme.palette.text.secondary}
        >
          Create a Bid Line Item to group categories so the pricing appears as a
          separate line on the bid.
        </Typography>
        <MiPlaceholderArea
          text="No Bid Line Items Created"
          helperText="Tip: To create, click + Add Bid Line Item."
          iconComponent={<img src={MiBuildHouseAlt} alt="House Icon" />}
          containerStyle={{
            backgroundColor: theme.palette.primary.light,
            height: "100%",
            minHeight: 450,
          }}
        />
      </Box>
    </ConfigAccordionHeader>
  );
}
